import React, { PureComponent } from 'react'
import { Button, Icon, Modal, Form, Input, message } from 'antd'
import styles from './index.scss'
import * as api from 'services/api/collect'
import { FormComponentProps } from 'antd/lib/form'

interface Props {
  onConfirm: React.EventHandler<any>
  loading?: boolean
}
interface State {
  folder: any[]
  swapId: number
  selected: number
  addPanel: boolean
  isEdit: boolean
  loading: boolean
}

class CollectPanel extends PureComponent<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      folder: [],
      swapId: undefined,
      selected: 0,
      addPanel: false,
      isEdit: false,
      loading: false,
    }
  }

  componentDidMount() {
    this.fetchCollectFolder()
  }

  async fetchCollectFolder() {
    const data = await api.collectList()
    this.setState({
      folder: data,
      selected: data ? data[0].collect_folder_id : 0,
    })
  }

  async fetchSaveFolder(name, id?) {
    try {
      const { msg } = await api.saveFavorite(id, name)
      message.success(msg || '添加成功')
      this.handleLoading(false)
      this.closeModal()
      this.fetchCollectFolder()
    } catch (err) {
      console.error(err)
      message.error('操作失败')
      this.handleLoading(false)
    }
  }

  handleLoading = (opa: boolean) => this.setState({ loading: opa })

  handleEdit = (e, id) => {
    e.stopPropagation()
    this.setState({
      swapId: id,
      addPanel: true,
      isEdit: true,
    })
  }

  handleSelect = id => {
    this.setState({
      selected: id,
    })
  }

  handleModal = () => this.setState({ addPanel: true })
  closeModal = () =>
    this.setState({ addPanel: false, isEdit: false, swapId: undefined })
  saveFolder = ({ text }) => {
    const { swapId } = this.state
    this.fetchSaveFolder(text, swapId)
  }

  handleConfirm = () =>
    !this.state.selected || this.state.selected === 0
      ? message.error('请选择收藏夹')
      : this.props.onConfirm(this.state.selected)

  render() {
    const { selected, folder, addPanel, isEdit } = this.state

    const addForm = ({
      loading,
      form: { getFieldDecorator, validateFields },
    }: FormComponentProps & { loading: boolean }) => {
      const catchInput = e => {
        e.preventDefault()
        this.handleLoading(true)
        validateFields((err, val) => {
          if (err) {
            this.handleLoading(false)
            return
          }
          this.saveFolder(val)
        })
      }
      return (
        <Form onSubmit={catchInput}>
          <Form.Item className={styles.collectInput}>
            {getFieldDecorator('text', {
              rules: [{ required: true, message: '请输入收藏夹名称！' }],
            })(<Input placeholder="请输入收藏夹名称" />)}
          </Form.Item>
          <Form.Item className={styles.collectBtn}>
            <Button
              loading={loading}
              htmlType="submit"
              size="large"
              type="primary"
            >
              {`确认${isEdit ? '修改' : '创建'}`}
            </Button>
          </Form.Item>
        </Form>
      )
    }

    const addModal = () => {
      const CForm: any = Form.create()(addForm)
      return (
        <Modal
          visible={addPanel}
          onCancel={this.closeModal}
          title={`${isEdit ? '编辑' : '创建'}收藏夹`}
          footer={null}
          style={{ top: '30%', maxWidth: 460 }}
          bodyStyle={{ padding: 0 }}
          destroyOnClose
        >
          <CForm loading={this.state.loading} />
        </Modal>
      )
    }

    const folderList =
      folder &&
      folder.map(({ folder_name, collect_folder_id: id }, idx) => (
        <div
          key={`collect-${idx}`}
          className={styles.collectItem}
          style={{
            backgroundColor: idx % 2 ? '#EFEFEF' : '#F8F8F8',
          }}
          onClick={() => this.handleSelect(id)}
        >
          <span>
            {folder_name}
            <span
              className={styles.collectEdit}
              onClick={e => this.handleEdit(e, id)}
            >
              修改
            </span>
          </span>
          <span>
            {selected === id && (
              <Icon type="check" style={{ color: '#3A9CFF' }} />
            )}
          </span>
        </div>
      ))

    return (
      <div>
        <div className={styles.collectInner}>
          <div onClick={this.handleModal} className={styles.collectAdd}>
            <Icon type="plus" style={{ color: '#3A9CFF' }} />
            创建新收藏夹
          </div>
          <div className={styles.collectList}>{folderList}</div>
        </div>
        <div className={styles.collectBtn}>
          <Button
            loading={this.props.loading || false}
            onClick={this.handleConfirm}
            size="large"
            type="primary"
          >
            收藏
          </Button>
        </div>
        {addModal()}
      </div>
    )
  }
}

export default CollectPanel
